import { createElement, FC, ReactNode } from 'react';

export interface TextLayoutProps {
  children?: ReactNode;
  size?: string;
  color?: string;
  element?: string;
  className?: string;
}

const TextLayout: FC<TextLayoutProps> = ({
  children,
  size = 'base',
  color = 'base',
  className,
  element = 'p',
  ...props
}) => {
  let textSizes;
  switch (size) {
    case '2xs':
      textSizes = 'text-xs/relaxed';
      break;
    case 'xs':
      textSizes = 'text-sm/relaxed';
      break;
    case 'sm':
      textSizes = 'text-md/relaxed';
      break;
    case 'base':
      textSizes = 'text-lg/relaxed';
      break;
    case 'lg':
      textSizes = 'text-xl/relaxed';
      break;
    case 'xl':
      textSizes = 'text-2xl/relaxed';
      break;
    case '2xl':
      textSizes = 'text-3xl/relaxed';
      break;
    case '3xl':
      textSizes = 'text-4xl/relaxed';
      break;
    case '4xl':
      textSizes = 'text-5xl/relaxed';
      break;
    case '5xl':
      textSizes = 'text-6xl/relaxed';
      break;
    case '6xl':
      textSizes = 'text-7xl/relaxed';
      break;
    default:
      textSizes = '';
  }

  let textColor;
  switch (color) {
    case 'inherit':
      textColor = 'text-inherit';
      break;
    case 'white':
      textColor = 'text-white';
      break;
    case 'black':
      textColor = 'text-black';
      break;
    case 'light':
      textColor = 'text-neutral-500';
      break;
    case 'dark':
      textColor = 'text-neutral-700';
      break;
    case 'darker':
      textColor = 'text-neutral-800';
      break;
    case 'primary':
      textColor = 'text-theme-primary';
      break;
    default:
      textColor = 'text-neutral-600';
  }

  return createElement(
    element,
    {
      className: `font-normal ${textSizes} ${textColor} ${className}`,
      ...props,
    },
    children
  );
};

export default TextLayout;
